import React from 'react'
import { Alert, Box, Typography } from '@mui/material'

const styles = {
    root: { display: 'flex', flexDirection: 'column', gap: 1.5, flexShrink: 0 },
    bar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        columnGap: 3,
        rowGap: 1.5,
        minHeight: 40,
    },
    title: { m: 0, fontWeight: 600, lineHeight: 1.3 },
    actions: { display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 },
}

export default function AppPageHeader({ title, actions, actionsLabel = 'Page actions', notice, onCloseNotice, children }) {
    return (
        <Box component='header' sx={styles.root}>
            <Box sx={styles.bar}>
                <Typography variant='h6' component='h2' sx={styles.title}>
                    {title}
                </Typography>
                {actions && (
                    <Box role='group' aria-label={actionsLabel} sx={styles.actions}>
                        {actions}
                    </Box>
                )}
            </Box>
            {notice?.message && (
                <Alert severity={notice.severity || 'error'} onClose={onCloseNotice}>
                    {notice.message}
                </Alert>
            )}
            {children}
        </Box>
    )
}